module.exports = __webpack_public_path__ + "static/media/thumbnail.dbb61d66.jpg";